// src/lib/advisorStatus.js
//
// Partner lead-status change. The advisor dashboard used to UPDATE tax_subjects
// and INSERT partner_lead_events straight from the browser, which needed partner
// RLS policies on those tables. This wrapper calls the SECURITY DEFINER RPC
// (supabase/migrations/015_partner_set_lead_status.sql) that checks the caller
// is a partner user, that the subject belongs to the caller's firm, then
// updates the status and logs the event in one transaction.
//
// The allowed statuses (new, contacted, converted, not_a_fit) are also listed
// inside the SQL function. If a status is ever added, change STATUS_META in
// AdvisorDashboard.js and the function in a new migration together.
//
// Returns { data, error } like any supabase.rpc call.

import { supabase } from './supabase'

export function setLeadStatus(subjectId, status) {
  return supabase.rpc('partner_set_lead_status', {
    p_subject_id: subjectId,
    p_status:     status,
  })
}
